/*
  Brand bestsellers (Bas, 2026-10-21): fetch the brand's live best-selling order
  (sections/brand-bestsellers-feed.liquid) and swap it in. The page first shows the
  fallback cards; on any error or an empty result it keeps them.
  Speed: the request is started by an inline script in the section, as soon as the
  browser reads it (not after the full page load), and the result is kept in sessionStorage for 10 minutes, so a
  second visit shows it at once. Storage is per visitor, so dealer prices stay theirs.
*/
if (!customElements.get('brand-bestsellers')) {
  const CACHE_MS = 10 * 60 * 1000;

  class BrandBestsellers extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.feedUrl;
      if (!url || this.dataset.source) return;
      this.cacheKey = `brand-bestsellers:${url}`;

      const cached = this.readCache();
      if (cached) {
        this.swap(cached, 'cache');
        return;
      }
      this.load(url);
    }

    async load(url) {
      try {
        // The section's inline script has usually started this request already.
        const early = window.brandBestsellersRequests && window.brandBestsellersRequests[url];
        let html = early ? await early : null;
        if (html === null && !early) {
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) return;
          html = await response.text();
        }
        if (html && this.swap(html, 'live')) this.writeCache(html);
      } catch (error) {
        // Keep the fallback cards.
      }
    }

    swap(html, source) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const max = Number(this.dataset.max) || 5;
      const items = Array.from(doc.querySelectorAll('[data-brand-bestseller-item]')).slice(0, max);
      const list = this.querySelector('[data-brand-bestsellers-list]');
      if (!items.length || !list) return false;
      list.replaceChildren(...items.map((item) => document.importNode(item, true)));
      this.dataset.source = source;
      // Hidden when the page had no fallback cards; show it now there are live ones.
      const section = this.closest('section');
      if (section) section.hidden = false;
      return true;
    }

    readCache() {
      try {
        const entry = JSON.parse(sessionStorage.getItem(this.cacheKey) || 'null');
        if (entry && Date.now() - entry.time < CACHE_MS) return entry.html;
      } catch (error) {
        // No storage: fetch as usual.
      }
      return null;
    }

    writeCache(html) {
      try {
        sessionStorage.setItem(this.cacheKey, JSON.stringify({ time: Date.now(), html }));
      } catch (error) {
        // Storage full or blocked: nothing to remember.
      }
    }
  }

  customElements.define('brand-bestsellers', BrandBestsellers);
}
